import React, { useEffect, useState, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import EnglishHeader from "./Component/Header/EnglishHeader";
import EnHomeHeader from "./Component/HeaderHome/EnHomeHeader";
import ArabicHeader from "./Component/Header/ArabicHeader";
import ArHomeHeader from "./Component/HeaderHome/ArHomeHeader";
import EnglishHeaderMobile from "./Component/Header/EnglishHeaderMobile";
import EnHomeHeaderMob from "./Component/HeaderHome/EnHomeHeaderMob";
import ArabicHeaderMobile from "./Component/Header/ArabicHeaderMobile";
import ArHomeHeaderMob from "./Component/HeaderHome/ArHomeHeaderMob";
import EnglishFooter from "./Component/Footer/EnglishFooter";
import ArabicFooter from "./Component/Footer/ArabicFooter";
import EnglishFooterMobile from "./Component/Footer/EnglishFooterMobile";
import ArabicFooterMobile from "./Component/Footer/ArabicFooterMobile";
import ScrollToTop from "./Component/ScrollUp/ScrollUp";
// pages
import Home from "./Pages/Home/Home";
import OurStory from "./Pages/About-us/OurStory/OurStory";
import OurValues from "./Pages/About-us/OurValues/OurValues";
import BoardMembers from "./Pages/About-us/BoardMembers/BoardMembers";
import MeetTheCows from "./Pages/About-us/MeetTheCows/MeetTheCows";
import MilkysFarm from "./Pages/ProductsJourney/MilkysFarm/MilkysFarm";
import OurFactory from "./Pages/ProductsJourney/OurFactory/OurFactory";
import Logistics from "./Pages/ProductsJourney/Logistics/Logistics";
import Csv from "./Pages/Csv/Csv";
import Careers from "./Pages/Careers/Careers";
import ReachUs from "./Pages/ReachUs/ReachUs";
import TheMilkman from "./Pages/OurBrands/TheMilkman/TheMilkman";
import Reefy from "./Pages/OurBrands/Reefy/Reefy";
import Recipes from "./Pages/OurBrands/Recipes/Recipes";

// ar Pages
import HomeAr from "./Pages/Home/HomeAr";
import OurStoryAr from "./Pages/About-us/OurStory/OurStoryAr";
import OurValuesAr from "./Pages/About-us/OurValues/OurValuesAr";
import BoardMembersAr from "./Pages/About-us/BoardMembers/BoardMembersAr";
import MeetTheCowsAr from "./Pages/About-us/MeetTheCows/MeetTheCowsAr";
import MilkysFarmAr from "./Pages/ProductsJourney/MilkysFarm/MilkysFarmAr";
import OurFactoryAr from "./Pages/ProductsJourney/OurFactory/OurFactoryAr";
import LogisticsAr from "./Pages/ProductsJourney/Logistics/LogisticsAr";
import CsvAr from "./Pages/Csv/CsvAr";
import CareersAr from "./Pages/Careers/CareersAr";
import ReachUsAr from "./Pages/ReachUs/ReachUsAr";
import RecipesAr from "./Pages/OurBrands/Recipes/RecipesAr";
import ReefyAr from "./Pages/OurBrands/Reefy/ReefyAr";
import TheMilkmanAr from "./Pages/OurBrands/TheMilkman/TheMilkmanAr";
import FindOurProducts from "./Pages/OurBrands/FindOurProducts/FindOurProducts";
import FindOurProductsAr from "./Pages/OurBrands/FindOurProducts/FindOurProductsAr";
//
import NotFound from "./Component/404/NotFound";
import JobsPage from "./Pages/Jobs/JobsPage";

export default function LanguageRoutes() {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const isHome = location.pathname === "/" || location.pathname === "/ar";
  const lastPathname = useRef(location.pathname);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
  }, [location.pathname]);

  const HeaderComponent = (() => {
    if (isHome && isSmallScreen) {
      return isArabic ? ArHomeHeaderMob : EnHomeHeaderMob;
    } else if (isHome) {
      return isArabic ? ArHomeHeader : EnHomeHeader;
    } else {
      return isSmallScreen ? (isArabic ? ArabicHeaderMobile : EnglishHeaderMobile) : isArabic ? ArabicHeader : EnglishHeader;
    }
  })();

  const FooterComponent = isSmallScreen ? (isArabic ? ArabicFooterMobile : EnglishFooterMobile) : isArabic ? ArabicFooter : EnglishFooter;

  useEffect(() => {
    if (lastPathname.current !== location.pathname) {
      lastPathname.current = location.pathname;
      window.location.reload();
    }
  }, [location.pathname]);

  const mainRoutes = [
    { path: "/", enComponent: <Home />, arComponent: <HomeAr /> },
    { path: "/Our-Story", enComponent: <OurStory />, arComponent: <OurStoryAr /> },
    { path: "/Our-Values", enComponent: <OurValues />, arComponent: <OurValuesAr /> },
    { path: "/board-members", enComponent: <BoardMembers />, arComponent: <BoardMembersAr /> },
    { path: "/meet-cows", enComponent: <MeetTheCows />, arComponent: <MeetTheCowsAr /> },
    { path: "/milkys-farm", enComponent: <MilkysFarm />, arComponent: <MilkysFarmAr /> },
    { path: "/our-factory", enComponent: <OurFactory />, arComponent: <OurFactoryAr /> },
    { path: "/Logistics", enComponent: <Logistics />, arComponent: <LogisticsAr /> },
    { path: "/csv", enComponent: <Csv />, arComponent: <CsvAr /> },
    { path: "/Careers", enComponent: <Careers />, arComponent: <CareersAr /> },
    { path: "/Reach-us", enComponent: <ReachUs />, arComponent: <ReachUsAr /> },
    { path: "/The-milkman", enComponent: <TheMilkman />, arComponent: <TheMilkmanAr /> },
    { path: "/Reefy", enComponent: <Reefy />, arComponent: <ReefyAr /> },
    { path: "/Recipes", enComponent: <Recipes />, arComponent: <RecipesAr /> },
    { path: "/Find-our-products", enComponent: <FindOurProducts />, arComponent: <FindOurProductsAr /> },
  ];

  const renderRoutes = (routes = false) => (
    <div data-scroll-section>
      <Routes>
        {routes.map(({ path, enComponent, arComponent }, index) => (
          <Route key={index} path={path} element={isArabic ? arComponent : enComponent} />
        ))}
        {routes.map(({ path, arComponent }, index) => (
          <Route key={index} path={`${path}/ar`} element={arComponent} />
        ))}

        <Route path="/Careers/:jobId" element={<JobsPage />} />
        <Route path="/Careers/:jobId/ar" element={<JobsPage />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );

  return (
    <>
      <>
        <ScrollToTop />
        <HeaderComponent />
        {renderRoutes(mainRoutes, true)}
        <FooterComponent />
      </>
    </>
  );
}
